import React from "react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ISearchResult } from "../interface";
import Icon from "components/icon";
import { handleKeyMoveList } from "utils/moveFunctions";

interface ISearchResultProps {
    model: string;
    value: ISearchResult[];
    onLink?: () => void;
}

export const SearchResult = (props: ISearchResultProps) => {
    const { value, model, onLink } = props;

    const { t } = useTranslation();

    const splitCamelCase = (text) => {
        // 1. Separate acronyms from following words
        let result = text.replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2");
        // 2. Separate normal camelCase words
        result = result.replace(/([a-z\d])([A-Z])/g, "$1 $2").replace("Package", "Chancellery");
        return result.split(" ");
    };

    return (
        <>
            <h1 className="gs-dropdown-key">
                {splitCamelCase(model)
                    .map((word) => t(word))
                    .join(" - ")}
            </h1>
            {value.map((r, fileKey) => {
                const fileLink = r.file;
                const otherParts = fileLink.split("/");
                const fileName = otherParts[otherParts.length - 1];

                return (
                    <Link
                        key={fileKey}
                        to={{
                            pathname: "/orders/chancellery",
                            state: { tab: modelToTabIndex[r.model], instances: [r.relatedId], showAll: true },
                        }}
                        className="result-link"
                        onClick={onLink}
                        onKeyDown={handleKeyMoveList}
                    >
                        <div className="result-grid">
                            <Icon name={["far", "file"]} />
                            <h1 className="result-item">{fileName}</h1>
                            <div className="result-info">{r.relatedInfo}</div>
                        </div>
                    </Link>
                );
            })}
        </>
    );
};

const modelToTabIndex = {
    ExpertiseAttachment: 2,
    PackageAttachment: 1,
    PackageLetter: 1,
};
